import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { IDesignationList } from '../../../Pages/UserDesignation/IDesignation';

interface IUpdate extends IReduxState<IDesignationList> {
  updateableDate?: IDesignationList;
}

export const UpdateDesignationSlicer = createSlice({
  name: 'UpdateDesignation',
  initialState: {
    data: {},
    isLoading: false,
    updateableDate: undefined,
  } as IUpdate,
  reducers: {
    updateDesignation: (state, _) => {
      state.isLoading = true;
    },
    successUpdateDesignation: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureUpdateDesignation: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    designationUpdateableData: (state, action) => {
      state.updateableDate = action.payload;
    },
    clearUpdateDesignationState: (state) => {
      state.data = {};
      state.updateableDate = undefined;
    },
    clearUpdateableData: (state) => {
      state.updateableDate = undefined;
    },
  },
});

export const {
  updateDesignation,
  failureUpdateDesignation,
  successUpdateDesignation,
  designationUpdateableData,
  clearUpdateDesignationState,
  clearUpdateableData,
} = UpdateDesignationSlicer.actions;

export default UpdateDesignationSlicer.reducer;
